import { render, staticRenderFns } from "./MainPic.vue?vue&type=template&id=c4ed7a56&"
import script from "./MainPic.vue?vue&type=script&lang=js&"
export * from "./MainPic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports